import { gtm } from "./gtm.js";

export function initOffersModal() {
	const modal = document.getElementById("lbh-offer-modal");
	const content = modal?.querySelector(".lbh-modal__content");
	if (!modal || !content) return;

	document.addEventListener("click", (e) => {
		if (e.target.matches(".js-open-modal")) {
			const title = e.target.dataset.title ?? "";
			const description = e.target.dataset.description ?? "";
			const img = e.target.dataset.img ?? "";
			content.innerHTML = `<div>
				<img src="${img}" alt="${title}" />
				<h3>${title}</h3>
				${description}
			</div>`;
			modal.classList.add("is-open");
			document.body.style.overflow = "hidden";
			gtm.modalOfferOpen({ offer_title: e.target.dataset.title ?? "" });
		}

		if (e.target.matches(".lbh-modal__close") || e.target.matches(".lbh-modal")) {
			closeModal();
		}
	});

	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") closeModal();
	});

	function closeModal() {
		modal.classList.remove("is-open");
		document.body.style.overflow = "";
	}
}
